import axios from 'axios'
import React from 'react'
import { useEffect, useState, useTimer, useSelector } from 'hooks'
import { isDev } from 'config/api.config'
import { AUTH, bannerUrl } from 'common/endpoints'
import { Button, SiteLogo, T } from 'components'
import StyledLogout from './StyledLogout'
import { isRetina } from 'styles'
import { BANNERS } from 'common/constants'

function Logout() {
  const { testAds, realAds } = useSelector(store => store.flags)
  const devMode = realAds ? 0 : testAds ? 1 : +isDev

  const [url, setUrl] = useState('')

  const progress = useTimer(5, () => (location.href = url))

  useEffect(() => {
    axios
      .post(AUTH.LOGOUT)
      .then(axios.get(bannerUrl(BANNERS.LOGOUT, devMode)))
      .then(r => axios.get(r.data.redirTo, { withCredentials: false }))
      .then(
        r => r.data.match(/href=\"(.+?)\"/)?.[1] || '/',
        () => '/'
      )
      .then(setUrl)
  }, [])

  return (
    <StyledLogout isRetina={isRetina}>
      <div className="logoutContainer">
        <div className="logoutStatus">
          <SiteLogo />
          <h1>
            <T label="logout/done" />! <T label="logout/youSuccessfullyLoggedOut" />!
            <br />
            <br />
            <T label="logout/didYouLogOutByMistake" />
          </h1>
          <T
            as={Button}
            label="logout/goBack"
            fill="filled"
            color="main"
            size="large"
            onClick={() => (location.href = '/')}
          />
        </div>
        <T as="div" className="redirMsg" label="logout/orWaitAndLetUsTakeYouReact" />
        <div className="redirCountdown" style={{ maxWidth: (50 * progress) / 5 + '%' }}>
          {url && progress}
        </div>
      </div>
    </StyledLogout>
  )
}

export default Logout
